import { useCallback, useContext, useState } from 'react';
import { asyncAttempt } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import {
  categoryToPriorityMap,
  useNotifications
} from '@namespace/notifications';
import { UserContext } from '@namespace/user';
import { setLimits } from '../../api/limits';

const useSetLimits = () => {
  const [isFetching, setIsFetching] = useState(false);

  const { t } = useI18n();
  const { errorNotification, successNotification } = useNotifications();
  const [, userActions] = useContext(UserContext);
  const { FETCH_USER_DATA } = userActions;

  const updateLimits = useCallback(
    async <T>(body: T) => {
      setIsFetching(true);

      const [error, result] = await asyncAttempt(setLimits, body);

      FETCH_USER_DATA();

      if (error) {
        console.error(error);
        errorNotification({
          message: t('responsibleGambling.limits.saveError'),
          priority: categoryToPriorityMap.RESPONSE_TO_ACTION
        });
      } else {
        successNotification({
          message: t('web.notification.responsiblegambling.limitset'),
          priority: categoryToPriorityMap.RESPONSE_TO_ACTION
        });
      }

      setIsFetching(false);
      return result;
    },
    [FETCH_USER_DATA, errorNotification, t, successNotification]
  );

  return {
    updateLimits,
    isFetching
  };
};

export default useSetLimits;
